import className from 'classnames/bind';
import { motion } from 'motion/react';
import React, { forwardRef } from 'react';

import styles from './Container.module.scss';
let cx = className.bind(styles);

export interface ContainerProps extends React.PropsWithChildren {
  className?: string;
  tag?: React.ElementType;
  fullWidth?: boolean;
}

const Container = forwardRef<HTMLDivElement, ContainerProps>(({ children, className, tag, fullWidth }, ref) => {
  const Tag = tag || 'div';
  return (
    <Tag ref={ref} className={cx(['container', className, { 'full-width': fullWidth }])}>
      {children}
    </Tag>
  );
});

export const MotionContainer = motion.create(Container);
export default Container;
